// api/Customer/PaymentRequests.js
import axios from "axios";
import Config from "../../utils/Config";
const baseUrl = Config.baseUrl;

class PaymentRequests {
  getJsonHeaders() {
    return {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${localStorage.getItem(
        "txtconnect_ng_user_token"
      )}`,
    };
  }

  // Get payment history with filters
  async getPaymentHistory(
    page = 1,
    limit = 15,
    search = "",
    sortBy = "",
    sortOrder = "desc",
    dateFrom = "",
    dateTo = "",
    status = "",
    packageName = "",
    network = ""
  ) {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        ...(search && { search }),
        ...(sortBy && { sort_by: sortBy }),
        ...(sortOrder && { sort_order: sortOrder }),
        ...(dateFrom && { date_from: dateFrom }),
        ...(dateTo && { date_to: dateTo }),
        ...(status && { status }),
        ...(packageName && { package: packageName }),
        ...(network && { network }),
      });

      const response = await axios.get(
        `${baseUrl}api/user/payment/history?${params.toString()}`,
        {
          headers: this.getJsonHeaders(),
        }
      );
      
      return {
        success: true,
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data || error.message,
        status: error.response?.status || 500,
      };
    }
  }
}

const paymentRequests = new PaymentRequests();
export default paymentRequests;